// extracted by mini-css-extract-plugin
module.exports = {"root":"Layout-root-1c7e2767b3a816be88ddb636c5e906cd"};